/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowDownToArc = createReactComponent("outline", "arrow-down-to-arc", "IconArrowDownToArc", [["path", { "d": "M12 3v12", "key": "svg-0" }], ["path", { "d": "M16 11l-4 4l-4 -4", "key": "svg-1" }], ["path", { "d": "M3 12a9 9 0 0 0 18 0", "key": "svg-2" }]]);

export { IconArrowDownToArc as default };
//# sourceMappingURL=IconArrowDownToArc.mjs.map
